"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const referralStatsInputs = [
  {
    name: "title",
    type: "string",
    required: true,
    defaultValue: "Your stats",
  },
  {
    name: "referralhistory",
    type: "string",
    friendlyName: "Label for link to referral history",
    required: true,
    defaultValue: "See my referrals history",
  },
  {
    name: "referralhistorylink",
    type: "url",
    friendlyName: "Url for link to referral history",
    required: true,
    defaultValue: "#",
  },
  {
    name: "referralstatslist",
    type: "list",
    required: true,
    subFields: [
      {
        name: "imageUrl",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        friendlyName: "Image",
        required: true,
        defaultValue:
          "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F9c9d5f47481440f7bede081417e1451a",
      },
      {
        name: "description",
        type: "string",
        required: true,
      },
      {
        name: "value",
        type: "string",
        enum: [
          {
            value: "totalReward",
            label: "Total reward element",
          },
          {
            value: "createdAccount",
            label: "Referees who created an account",
          },
          {
            value: "completedFirstOrder",
            label: "Referees who completed the first order",
          },
        ],
        required: true,
      },
    ],
    defaultValue: [
      {
        imageUrl:
          "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F9c9d5f47481440f7bede081417e1451a",
        description: "You have earned until now",
        value: "totalReward",
      },
      {
        imageUrl:
          "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F9c9d5f47481440f7bede081417e1451a",
        description: "Used your referral code to create an account",
        value: "createdAccount",
      },
      {
        imageUrl:
          "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F9c9d5f47481440f7bede081417e1451a",
        description: "Completed a first order",
        value: "completedFirstOrder",
      },
    ],
  },
] as const satisfies Inputs;

export const ReferralStatsComponent: RegisteredComponent = {
  name: "ReferralStats",
  component: dynamic(async () =>
    withValidation(referralStatsInputs, (await import("./ReferralStats")).ReferralStats, "ReferralStats")
  ),
  inputs: referralStatsInputs,
  requiresParent: {
    query: {
      "component.name": { $in: ["LoyaltyWrapper"] },
    },
    message: "'ReferralStats' component can only be added inside a 'LoyaltyWrapper'",
  },
};
